import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export const ModalResponsibleDuplicated = ({ show, onClose }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <SweetAlert
      warning
      title={t("clinicalTrials.general.responsibleAlreadySelectedTitle")}
      onConfirm={onClose}
      confirmBtnBsStyle="danger"
      confirmBtnText={t("buttons.close")}
      showCancel={false}
    >
      {t("clinicalTrials.general.responsibleAlreadySelectedMessage")}
    </SweetAlert>
  );
};

ModalResponsibleDuplicated.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
